import { Trans, useTranslation } from "react-i18next"

import util from "utils/utils"

export default function IdeaSubmittedContent({ events, ownerChallenge }) {
  const { t } = useTranslation()
  return (
    <Trans
      i18nKey="notifications.ideaSubmitted"
      values={{
        name: util.getEventNames(events),
        ideaLabel: events.length > 1 ? t("generic.ideas") : t("generic.idea"),
        ideas: events.map((e) => e.ownerIdea?.name || "Deleted").join(" "),
        challenge: ownerChallenge?.name || "Deleted",
      }}
      components={{ b: <b /> }}
    />
  )
}
